import dayjs from "dayjs";

export const clock = (dateObj) => {
  let date = new Date();
  if (dateObj !== null && dateObj !== undefined) {
    date = new Date(dateObj);
  }
  let hours = date.getHours();
  let minutes = date.getMinutes();
  let ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12;
  hours = hours < 10 ? "0" + hours : hours;
  minutes = minutes < 10 ? "0" + minutes : minutes;
  const time = hours + ":" + minutes + " " + ampm;
  return time;
};

export const timeStamp = (dateObj) => {
  let date = new Date();
  if (dateObj !== null && dateObj !== undefined) {
    date = new Date(dateObj);
  }
  return date.toISOString().split("T")[0] + " " + date.toTimeString().split(" ")[0];
};

export const timeValidator = (sTime, eTime, cTime) => {
  const startDate = sTime ? dayjs(sTime).format("DD-MM-YYYY HH:mm:ss") : dayjs("2000-01-01").format("DD-MM-YYYY HH:mm:ss");
  const endDate = eTime ? dayjs(eTime).format("DD-MM-YYYY HH:mm:ss") : dayjs("2050-01-01").format("DD-MM-YYYY HH:mm:ss");
  const curDate = cTime ? dayjs(cTime).format("DD-MM-YYYY HH:mm:ss") : dayjs(new Date()).format("DD-MM-YYYY HH:mm:ss");
  return curDate >= startDate && curDate <= endDate;
};

export const dateValidator = (sDate, eDate, cDate) => {
  // Read the clock once: with no end date, "now" was read twice and a 1 ms tick between the reads
  // made now > end, so a rule with no end date was skipped at random on a busy PC.
  const now = dayjs();
  const startDate = sDate ? dayjs(sDate) : dayjs("2000-01-01");
  const endDate = eDate ? dayjs(eDate) : now;
  const currentDate = cDate ? dayjs(cDate) : now;
  return (currentDate.isAfter(startDate) || currentDate.isSame(startDate)) && (currentDate.isBefore(endDate) || currentDate.isSame(endDate));
};

export const currentDay = () => {
  const date = new Date();
  const days = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
  return days[date.getDay()];
};
